module.exports = __webpack_public_path__ + "img/lavender-logo.9f2d80fb.jpg";